import type { RouteRecordRaw } from 'vue-router'
import { TablePostPage } from '@myorg/menu-editor-lib'
import api from '../../services/api'
import {ROUTES, API_ENDPOINTS} from '@myorg/type-lib'

export const tablePostApi = {
  getTables: async (): Promise<any[]> => {
    const res = await api().get(API_ENDPOINTS.BFF.TABLES_WITH_QR);
    return res.data;
  },
  createTables: async (nums: number): Promise<any[]> => {
    const res = await api().post(`${API_ENDPOINTS.MENU.TABLE}?nums=${nums}`, {});
    return res.data;
  }
}

export const TablePostRoute: RouteRecordRaw = {
  path: ROUTES.TABLE_POST.PATH,
  name: ROUTES.TABLE_POST.NAME,
  component: TablePostPage,
  props: { api: tablePostApi }
}
